export var UNKNOWN_CODE = 'code#unknown';
export var INJECT_ECOMMERCE = process.env.INJECT_ECOMMERCE;
export var PACKAGE_PARAM_REGEX = /[&|?]package_index=\d{1,}/;